<template>
  <div style="">
    <template>
      <el-dialog v-dialogDrag :style="[{height: `${ height }` }]" :visible.sync="dialogVisible" :width="width" :close-on-click-modal="false" :before-close="handleClose" append-to-body class="status_change">
        <div slot="title" class="dialog-title">
          <span class="title-text" style="color: #FFFFFF;font-weight: bold;font-size: 16px;display: inline-block;position: absolute;top: 10px;left: 16px;font-size: 16px;">{{ title }}</span>
          <div class="button-right">
            <span class="title-close" @click="cancel"></span>
          </div>
        </div>
        <slot></slot>
        <span slot="footer" class="dialog-footer" v-if="OKASCAN">
          <div class="hr" :style="{ width: `${ width }` }"></div>
          <button @click="cancel" style="min-width: 64px;height: 32px;text-align: center;border-radius: 2px;margin-left: 5px;margin-top: 5px;padding: 0px 10px;" v-if="CancelFlag">{{ leftText }}</button>
          <button @click="dialogOK" style="min-width: 64px; background-color: #E71D43;color: #FFF; height: 32px; padding-left: 10px;padding-right: 10px;text-align: center;border-radius: 2px;margin-left: 5px;" v-if="dialogOKFlag">{{ rigthText }}</button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: { //状态
      type: Boolean,
      default: false
    },
    // dialog标题
    title: {
      type: String,
      default: '新增用户'
    },
    OKASCAN: {
      type: Boolean,
      default: true
    },
    // dialog宽度
    width: {
      type: String,
      default: '1000px'
    },
    height: {
      type: String,
      default: '100%'
    },
    // 返回按钮文字
    leftText: {
      type: String,
      default: '取消'
    },
    // 确定按钮文字
    rigthText: {
      type: String,
      default: '确认'
    },
    // 是否开启弹窗返回/关闭按钮
    CancelFlag: {
      type: Boolean,
      default: true
    },
    // 是否开启弹窗确认按钮
    dialogOKFlag: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    dialogOK() {
      this.$emit('dialogOK')
    },
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less">
.status_change {
  .el-dialog__header {
    background-color: #00266d;
    height: 8px;

    .el-dialog__title,
    .el-dialog__headerbtn i {
      color: white;
    }

    .el-dialog__headerbtn {
      position: absolute;
      top: 10px;
    }
  }
}
.el-dialog__body{
  overflow: hidden;
}
.hr {
  width: 1000px;
  position: relative;
  right: 20px;
  display: inline-block;
  border-top: 2px solid #f0f0f0;
}
button{
  cursor: pointer;
}
</style>